import styled from '@emotion/styled'

import { Space } from '../../atoms'

export const StyledBox = styled(Space)`
  border-radius: 8px;
`

export type StyledSummaryProps = {
  isExpanded: boolean
}

export const StyledSummary = styled(Space)<StyledSummaryProps>`
  cursor: pointer;
  &:hover {
    background: ${props => (props.isExpanded ? 'var(--White)' : 'var(--White90)')};
  }
`

export const StyledIconWrapper = styled(Space)`
  padding-top: 1px;
`
